import I18n from 'i18n-js'

import type { AllClientsRow, QueryRow } from './types'

// A link to the unfiltered client list, shown alongside the saved queries. It
// has no publisher, visibility or creation date, which is why the filters skip
// it.
export const ALL_CLIENTS_ID = 0

export const allClientsLabel = (): string =>
  I18n.t('segments.modal.all_companies')

export const newQueryLabel = (): string =>
  I18n.t('companies_overview.segments.new_query')

// The name a query page carries before it holds a saved query.
export const unsavedQueryLabel = (isNewQuery: boolean): string =>
  isNewQuery ? newQueryLabel() : allClientsLabel()

// Keep this out of the shared list of saved queries: id 0 doubles as the
// fallback key for a run with no query, so it would show up under
// "Recently visited".
export const allClientsQuery = (): AllClientsRow => ({
  id: ALL_CLIENTS_ID,
  name: allClientsLabel(),
  description: I18n.t('companies_overview.segments.all_clients_description'),
  recommended: false,
  insight_triggers_count: 0,
  permissions: {},
})

export const isAllClientsQuery = <
  T extends Pick<QueryRow, 'id' | 'partner_segment_id'>
>(
  query: T
): query is T & AllClientsRow =>
  query.id === ALL_CLIENTS_ID && !query.partner_segment_id
